import React, { useEffect } from 'react';

const DashbarIntentListnerWrapper = ({ children, setDashbarContext }) => {
  let previousValue = localStorage.getItem('EMALPHA_DASHBAR_CURRENCY_PAIR',"USDJPY");
  
  useEffect(() => {
    setInterval(() => {
      const currentValue = localStorage.getItem('EMALPHA_DASHBAR_CURRENCY_PAIR');
      if (currentValue !== previousValue) {
        setDashbarContext(currentValue);
        previousValue = currentValue; // Update the previous value
      }
    }, 1000); 


  }, [setDashbarContext]); // Added setContext to the dependency array for safety.


  return children;
};

export default DashbarIntentListnerWrapper;
